import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {ModalidadeFinanciamento} from '../model/vaga.model';

@Injectable({
  providedIn: 'root'
})
export class ModalidadeFinanciamentoService {
  private apiUrl = `${environment.fullApiUrl}/modalidade-financiamento`;
  private http = inject(HttpClient);

  /**
   * Obtém a lista de todas as modalidades de financiamento
   */
  obterTodos(): Observable<ModalidadeFinanciamento[]> {
    return this.http.get<ModalidadeFinanciamento[]>(this.apiUrl);
  }

}
